import React, { useState } from 'react';
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from "react-toastify";
import BaasVaasConfig from '../../models/BaasVaasConfig.js';
import FormPartial from "./FormPartial.js";
import { useNavigate } from "react-router-dom";

const New = (props) => {
    const [baasVaasConfig, setBaasVaasConfig] = useState(new BaasVaasConfig());
    const [createApi] = getApi('mapUserServiceType');
		let baasVaasConfigObj = new BaasVaasConfig();
    const navigate = useNavigate();

    const createRecord = async (params) => {
      try {
        await createApi(params).unwrap();
        toast.success("User mapped to service types successfully.");
        navigate(-1);
      } catch (error) {
  			baasVaasConfigObj.set_api_errors(error.data.errors);
        toast.error(error.data?.message || "Something went wrong");
      }
    }

    const onSubmitClick = () => {
      try{
        createRecord(new BaasVaasConfig(baasVaasConfig).toApiJson());
      } catch(error){
        setBaasVaasConfig(new BaasVaasConfig(baasVaasConfig));
      }
    }

    const onBackClick = () => {
      navigate(-1);
    }

    return <Page
        uiPage={uiManager.getUiPage(PAGES.NewServiceTypeMappingPage.name)}
        breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "Service Type Mapping", url: '/service_type_mapping'}, { label: "New" }]}
        className={'baas-vaas-mapping-page'}
    >
      <PageContentWrapper contentHeading={"New Service Type Mapping"}>
        <div className='m-3'>
          <form className="row g-4" autoComplete="off" onKeyDown={e => e.key === 'Enter' && e.preventDefault()}>
            <FormPartial baasVaasConfig={baasVaasConfig} setBaasVaasConfig={setBaasVaasConfig}/>
            <div className='mb-4 col-md-12'>
              <div>
                <button type="button" className="btn btn-voltup-theme" onClick={onSubmitClick}>Submit</button>
                <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={onBackClick}>Back</button>
              </div>
            </div>
          </form>
        </div>
      </PageContentWrapper>
    </Page>
};

export default New;
